export default __webpack_public_path__ + "assets/images/icon_ingredients.86c1da18e01a81e922276ea245e89d73.svg";